/**
 * Onboarding Service
 * Handles initial company + admin registration flow (PostgreSQL backend)
 */

import apiClient from './apiClient';

export interface OwnerPayload {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    password: string;
    rolePassword: string;
}

export interface CompanyPayload {
    name: string;
    phone: string;
    email: string;
}

export interface InitialRegisterPayload {
    owner: OwnerPayload;
    company: CompanyPayload;
    termsAccepted?: boolean;
}

export interface InitialRegisterResponse {
    success: boolean;
    message?: string;
    data?: {
        companyId: string;
        ownerId: string;
        phoneNumber?: string;
        smsVerificationSent?: boolean;
    };
}

export const onboardingAPI = {
    registerCompany: (payload: InitialRegisterPayload) =>
        apiClient.post<InitialRegisterResponse>('/onboarding/initial-register', payload),

    resendVerificationEmail: (email: string) =>
        apiClient.post('/auth/send-verification', { email })
};

export default onboardingAPI;

